import { api } from '../api/client';
import { API_PACKAGES_URL } from '../utils';

// Discover first, for a person creating a card from scratch (KPR-1440). The
// ranked search (keepr-api KPR-1432, GET /api/packages?search=) answers best
// match first; this reads only the top row and only when keepr calls it
// `strong`. Its own module so the Discover service stays untouched.

/** The best package for the words, or null when none is a strong match. */
export async function findStrongPackage(words, { signal } = {}) {
	const { data } = await api.get(API_PACKAGES_URL, { params: { search: words, limit: 1 }, signal });
	const top = Array.isArray(data) ? data[0] : null;
	return top && top.strong === true && top.key ? top : null;
}
